export const currentVersion = import.meta.env.VITE_REACT_APP_VERSION;
const versionParts = currentVersion.split('.');
export const versionAsNumber = parseInt(`${versionParts[0].padStart(3, '0')}${versionParts[1].padStart(3, '0')}${versionParts[2].padStart(3, '0')}`, 10);
